import React from "react"
import {
  ANIMALS_REPORTS_VIEW,
  FARM_REPORTS_VIEW,
  REPORTS_VIEW,
} from "./route-list"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const ReportsPage = React.lazy(
  () => import("@/features/reports/views/reports-page/reports-page"),
)

const FarmReportsPage = React.lazy(
  () => import("@/features/reports/views/farm-reports-page/farm-reports-page"),
)

const AnimalsReportsPage = React.lazy(
  () =>
    import("@/features/reports/views/animal-reports-page/animal-reports-page"),
)

export const reportsRoutes = [
  {
    path: REPORTS_VIEW,
    element: <ReportsPage />,
  },
  {
    path: FARM_REPORTS_VIEW,
    element: <FarmReportsPage />,
  },
  {
    path: ANIMALS_REPORTS_VIEW,
    element: <AnimalsReportsPage />,
  },
]

const MOBILE_REPORTS_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: reportsRoutes,
  },
]

const DESKTOP_REPORTS_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: reportsRoutes,
  },
]

export const getReportsRoutes = (isDesktop: boolean) => {
  return isDesktop ? DESKTOP_REPORTS_ROUTES : MOBILE_REPORTS_ROUTES
}
